<!-- src/components/device/AlarmeNonVue.vue -->
<!--
  Alarme non vue (B11, 02/10/2026) — espace client : tableau de bord et fiche.

  Le serveur n'a pas d'état « déclenché » : une alarme est un événement. Ce bandeau ne se déduit
  donc PAS de l'historique — il suit `alarm_unseen`, que le serveur pose à chaque alarme ou
  sabotage et efface au premier « J'ai vu » d'une personne du compte, ou au désarmement. Même
  règle dans l'app mobile : une interface qui la recalculerait finirait par dire autre chose.
-->
<template>
  <div v-if="alarme" class="rounded-md bg-red-50 border border-red-300 text-red-800" @click.stop>
    <div :class="['flex items-center justify-between gap-3', compact ? 'px-3 py-2' : 'px-4 py-3']">
      <div class="flex items-center gap-2 min-w-0">
        <span class="inline-block w-2 h-2 rounded-full bg-red-500 animate-pulse flex-shrink-0"></span>
        <div class="min-w-0">
          <!-- Le nom de ce qui a déclenché, à côté de l'heure, comme la notification de l'app
               (05/10/2026) : « Alarme à 16:44 — porte garage ». Nom de l'entrée filaire ou de
               l'accessoire ; rien de plus s'il n'a pas de nom. -->
          <div :class="['font-semibold', compact ? 'text-sm' : '']">
            {{ $t('alarmeNonVue.titre', { quand: quand }) }}<template v-if="source"> — {{ source }}</template>
          </div>
          <div v-if="alarme.count > 1" class="text-xs">{{ $t('alarmeNonVue.plusieurs', { n: alarme.count }) }}</div>
        </div>
      </div>
      <button type="button" @click.stop="voir" :disabled="envoi"
              class="flex-shrink-0 px-3 py-1.5 rounded-md border border-red-300 bg-white text-red-800 text-sm font-semibold hover:bg-red-100 disabled:opacity-50">
        {{ envoi ? '…' : $t('alarmeNonVue.jaiVu') }}
      </button>
    </div>
    <p v-if="!compact" class="px-4 pb-3 -mt-1 text-xs text-red-700">{{ $t('alarmeNonVue.aide') }}</p>
    <p v-if="erreur" class="px-4 pb-2 text-xs font-medium">{{ erreur }}</p>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { format, parseISO, isToday } from 'date-fns';
import { localeDateFns, enParis } from '@/i18n/dates';
import { texteErreur } from '@/i18n/serveur';
import apiService from '@/services/api.service';

export default defineComponent({
  name: 'AlarmeNonVue',
  props: {
    device:  { type: Object, required: true },
    compact: { type: Boolean, default: false }
  },
  emits: ['vue'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const envoi = ref(false);
    const erreur = ref('');
    const alarme = computed(() => props.device && props.device.alarm_unseen);
    const source = computed(() => {
      const p = alarme.value && alarme.value.params;
      return (p && (p.nom || p.accessoire)) || '';
    });
    const quand = computed(() => {
      if (!alarme.value || !alarme.value.at) return '';
      try {
        const p = enParis(parseISO(alarme.value.at));
        return format(p, isToday(p) ? 'HH:mm' : 'dd MMM HH:mm', { locale: localeDateFns() });
      } catch { return alarme.value.at; }
    });
    const voir = async () => {
      envoi.value = true; erreur.value = '';
      try {
        await apiService.marquerAlarmeVue(props.device.id);
        emit('vue');
      } catch (e) {
        erreur.value = texteErreur(e, t('alarmeNonVue.echec'));
      } finally {
        envoi.value = false;
      }
    };
    return { alarme, source, quand, envoi, erreur, voir };
  }
});
</script>
